import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  parrotS: {
    width: 250,
    height: 'auto',
  },
}));

export default useStyles;
